module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADSSURBVHgB7doxDsIwEETRAVHQhS434BacnlPACQgVlHQk0CHLWrtAduY/yZVdJFPY3k0kAADgahNYc1LfzrnJrcwRgMzZB7BTnWkeT7VlmMeoQrUBPOZxV3uKA2APkDkCkDkCkLlIMZQ6WpZj8KW27PW9C/yaBAAAUiL3gKP6ds1NRvoBxTV2Y7IBUAvIHE3RwJqbAADAGtk3RSMXoVQ1eFF7H0eXl089azYAagGZIwCZIwCZq/1H6KDYHeKfBlWoDWBU/83SD/YAmSMAAQAAmHoD2p0RbinTYIcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/web_mobile_sidebar_icon02_nor.png
// module id = aJiw
// module chunks = 1